<template>
  <div :class="['stand-input-wrapper', { 'stand-input': myType !== 'switch' && myType !== 'text'}]">
    <div
      v-if="myType === 'input'"
      class="stand-input-core"
      style="{marginLeft}"
    >
      <el-input
        :disabled="disabled"
        type="text"
        @blur="handleInputChange"
        v-model="myData"
        v-bind:readonly="readonly"
        size="mini"
      />
      <div v-if="unit" class="unit">{{ unit }}</div>

    </div>
      <!-- <i v-if="icon" :class="icon"></i> -->

    <div v-if="myType === 'text'">
      {{myData}}
    </div>
    <div v-if="myType === 'select'" class="stand-select-core">
      <el-select
        :default-first-option="true"
        v-model="myData"
        placeholder=""
        :multiple="multiple"
        :disabled="disabled"
        @change="handleChange"
        size="mini"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.value"
          :style="{
            color: item.markFlag === 1 ? '#67c23a' : 'rgb(96, 98, 102)'
          }"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div v-if="myType === 'switch'" class="stand-switch-core">
      <el-switch v-model="myData" active-color="#537DFC"> </el-switch>
    </div>
  </div>
</template>

<script>
// import { checkNumber, checkIntergerNumber } from './utils';
export default {
  props: {
    selectOptions: {
      type: Array,
      default: () => []
    },
    myType: {
      type: String,
      default: 'input'
    },
    unit: {
      type: String,
      default: ''
    },
    value: {
      require: true
    },
    onlyNumber: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    interger: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: String
    },
    icon: {
      type: String
    }
  },
  data() {
    return {
      myData: null
    };
  },
  watch: {
    value: {
      handler(val) {
        this.myData = val;
      },
      immediate: true
    },
    myData: {
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange(val) {
      console.log(val);
      this.$emit('change', val);
    },
    handleInputChange(e) {
      let newValue = e.target.value.replace(/[^0-9.]/g, '');
      if (this.onlyNumber) {
        if (this.interger) {
          newValue = newValue.replace(/\..*/, '')
          newValue = newValue.replace(/^0+/, '') || '0'
          this.myData = newValue;
        } else {
          const parts = newValue.split('.');
          if (parts.length > 1) {
            parts[0] = parts[0].replace(/^0+/, '') || '0'
            newValue = parts[0] + '.' + parts[1];

            if (parts[1].length > this.precision) {
              newValue = parts[0] + '.' + parts[1].slice(0, this.precision);
            }
          } else {
            newValue = newValue.replace(/\..*/, '')
            newValue = newValue.replace(/^0+/, '') || '0'
          }
        }
        if (this.min !== undefined && parseFloat(newValue) < this.min) {
          newValue = this.min;
        }
        if (this.max !== undefined && parseFloat(newValue) > this.max) {
          newValue = this.max;
        }
        this.myData = newValue;
      } else {
        this.myData = newValue;
      }
      this.$emit('change', e.target.value);
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep.el-select-dropdown__item{
  height:26px;
  line-height: 26px;
  font-size: 12px;
}
.stand-input-wrapper {
  display: inline-block;
  position: relative;
}
.stand-input-core {
  display: flex;
  align-content: center;
  .el-input {
    input {
      border: none;
      outline: none;
      font-size: 12px;
      width: 100%;
      height: 24px;
      line-height: 24px;
    }
  }
}
.cus-input {
  border: none;
  width: 100%;
  padding-right: 15px;
  height: 30px;
  outline: none;
  font-size: 14px;
}
.unit {
  position: absolute;
  right: 5px;
  top: 50%;
  font-size: 12px;
  color: #999;
  transform: translateY(-50%);
}
</style>

<style lang="less">
.stand-select-core {
  position: relative;
  top: 1px;
  height: 100%;
  .el-select {
    width: 100%;

    .el-input--suffix .el-input__inner {
      //padding-right: 0px !important;
    }
    .el-input__inner {
      width: 100%;
      //padding-left: 0px;
    }
    .el-input__suffix {
      height: auto;
      right: 5px;
      //display: none;
    }

    .el-input__icon{
      width: 15px;
    }

    .el-input {
      input {
        //border: none;
        outline: none;
        font-size: 12px;
        width: 100%;
        height: 24px;
        line-height: 24px;
      }
    }
  }
}
</style>
<style lang="less">
.stand-switch-core {
  position: relative;
  top: 3px;
  height: 100%;
}
</style>
